<div class="row">
  <div class="slider-container">
    <span class="label">{{ valueTitle }}</span>
    <input type="range" (mousemove)="changeValue($event.target.value)" #slider />
  </div>
</div>